module.exports = __webpack_public_path__ + "static/media/deletegray.cca6ac14.svg";